import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import _ from 'lodash';
import Select from 'react-select';
import * as styles from './stepperStyle';

import NameInput from '../../Components/PersonalInputs/NameInput';
import DateInput from '../../Components/DateInput';
import PhoneInput from '../../Components/PhoneInput';
import EmailInput from '../../Components/EmailInput';
import { ReceiptTwoTone } from '@material-ui/icons';
import { CompletedContext } from './StepperComponent';
import { validate } from '../../../utils/validateInputs';

import { saveApplicant, apllicantData } from '../../../redux/actions/applicantAction';
import { history } from "../../../utils/hist";
import { makeStyles } from '@material-ui/core/styles';

const usePath = (props) => {
  const [path, setPath] = React.useState(false);
  // console.log(props.pathName);
  React.useEffect(() => {

    if (props.pathName === '/profile-page/add') {
      setPath(true);
    }

  }, [props.pathName]);

  return path;
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const useCompleted = () => {
  const contextValue = React.useContext(CompletedContext);
  return contextValue;
};

const Profile = props => {
  const classes = useStyles();
  const [completed, dispatch] = useCompleted();

  const [submitted, setSubmitted] = React.useState(false);
  const handleChange = React.useCallback(
    _.debounce(q => props.handleApplicantChange(q), 500),
    []
  );

  const handleInputChange = e => {
    const { target } = e;
    handleChange(target);
  };

  const handleSelectChange = React.useCallback(
    name => select => {
      props.handleSelectApplicantChange(name, select);
    },
    []
  );
  const addPath = usePath(props);
  // console.log(addPath, 'addPatchProfile');
  
  const handleSaveProfile = () => {
    // console.log(addPath ? 0 : props.application.id);
    const newCompleted = completed;
    const data = {
      id: addPath ? 0 : props.application.id,
      // subdivision: props.applicant.subdivision,
      submittertype: props.applicant.i_submittertype,
      surname: props.applicant.surname,
      name: props.applicant.name,
      patronymic: props.applicant.fathername,
      gender: props.applicant.gender,
      birth: props.applicant.bithdaydate,
      citizenship: props.applicant.nationality,
      phone: props.applicant.telephone,
      email: props.applicant.email
    };
    props.saveApplicant(data)
    .then(response => {
      newCompleted[props.activeStep] = true;
      // props.setCompleted(newCompleted);
      // props.handleNext();
      dispatch({ type: 'COMPLETED', payload: newCompleted });
      props.apllicantData(props.application.id);
      props.handleNext()
      })
    .catch(err => {
      newCompleted[props.activeStep] = false;
      dispatch({ type: 'COMPLETED', payload: newCompleted });
    });
    
    if (addPath) {
      history.push('/profile-page/edit');
    }
  };

  const valid = validate(props.applicant);

  React.useEffect(() => {
    // const newCompleted = props.completed;
    setSubmitted(true);
    const newCompleted = completed;
    if (
      !!props.applicant.gender &&
      !!props.applicant.nationality &&
      !!props.applicant.i_submittertype &&
      !!valid.phone &&
      !!valid.email &&
      !!valid.dateB
    ) {
      // newCompleted[props.activeStep] = true;
      // // props.setCompleted(newCompleted);
      // // props.handleNext();
      // dispatch({ type: 'COMPLETED', payload: newCompleted });
    } else {
      // const newCompleted = props.completed;
      // newCompleted[props.activeStep] = false;
      // // props.setCompleted(newCompleted);
      // dispatch({ type: 'COMPLETED', payload: newCompleted });
    }
    // console.log(previousCompleted.current , props.completed[0]);
    // if (previousCompleted.current !== props.completed[0]) {
    //     props.setCompleted(newCompleted);
    //     previousCompleted.current = props.completed[0];
    // }
  }, [
    props.applicant.gender,
    props.applicant.nationality,
    props.applicant.i_submittertype,
    props.applicant.telephone,
    props.applicant.email,
    props.applicant.bithdaydate
  ]);

  return (
    <Grid container>
      {/* firstname lastename surname row */}

      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="surname">Прізвище </label>{' '}
            <NameInput
              // className={submitted && !props.applicant.surname && 'error'}
              name="surname"
              value={props.applicant.surname.toUpperCase()}
              onChange={handleChange}
              type="text"
              disabled={true}
            />{' '}
            {/* {submitted && !props.applicant.surname && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '} */}
          </div>{' '}
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="name">Ім`я</label>
            <NameInput
              // className={submitted && !applicant.name && 'error'}
              name="name"
              value={props.applicant.name.toUpperCase()}
              onChange={handleChange}
              type="text"
              disabled={true}
            />{' '}
            {/* {submitted && !applicant.name && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '} */}
          </div>{' '}
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="fathername">По батькові </label>{' '}
            <NameInput
              // className={(submitted && !applicant.fathername) && 'error'}
              name="fathername"
              value={props.applicant.fathername.toUpperCase()}
              onChange={handleChange}
              type="text"
              disabled={true}
            />{' '}
            {/* {(submitted && !applicant.fathername) && <FormHelperText error id="name-error-text">Поле обов'язкове</FormHelperText>} */}{' '}
          </div>{' '}
        </Grid>
      </Grid>
      {/* container start */}
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="bithdaydate">Дата народження </label>{' '}
            <DateInput
              className={!valid.dateB ? 'error' : ''}
              name="bithdaydate"
              value={props.applicant.bithdaydate}
              onChange={handleInputChange}
              type="text"
            />
            {!(submitted && !props.applicant.bithdaydate) && !valid.dateB && (
              <FormHelperText error id="name-error-text">
                {' '}
                Не валідне значення поля
              </FormHelperText>
            )}{' '}
            {submitted && !props.applicant.bithdaydate && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '}
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <div className="form-item">
            <label htmlFor="gender"> Стать </label>{' '}
            <div className="selectWrapper">
              <Select
                className={(submitted && !props.applicant.gender ) ? 'error' : ''}
                //className="select"
                //value={applicant.gender}
                //value={((directories || []).gender ).filter(({value}) => value === applicant.gender)}
                value={props.directories.gender.filter(
                  ({ value }) => value === parseInt(props.applicant.gender)
                )}
                //value={[{label: 'John', value: 1}]}
                onChange={handleSelectChange('gender')}
                name="gender"
                options={props.directories.gender}
                // isLoading={
                //   props.isFatching.DATA_FROM_DIRECTORIES
                // }
                styles={styles.customStyles} //custom settings
                theme={styles.customTheme} //resolve problems with border-radius
                placeholder=""
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body} // resolve problem with z-index of options
              />{' '}
              {submitted && !props.applicant.gender && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <div className="form-item">
            <label htmlFor="nationality">Громадянство </label>{' '}
            <div className="selectWrapper">
              <Select
                className={(submitted && !props.applicant.nationality) ? 'error' : ''}
                //value={applicant.nationality}
                value={props.directories.citizenShip.filter(
                  ({ value }) => value === parseInt(props.applicant.nationality)
                )}
                onChange={handleSelectChange('nationality')}
                name="nationality"
                //options={((directories || []).citizenShip )}
                options={props.directories.citizenShip}
                styles={styles.customStyles}
                placeholder=""
                // isLoading={
                //   this.props.isFatching.DATA_FROM_DIRECTORIES
                // }
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !props.applicant.nationality && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <div className="form-item">
            <label htmlFor="cateroty">Категорія заявника </label>{' '}
            <div className="selectWrapper">
              <Select
                //value={applicant.i_submittertype}
                value={props.directories.submitterType.filter(
                  ({ value }) => value === props.applicant.i_submittertype
                )}
                className={
                  (submitted && !props.applicant.i_submittertype) ? 'error' : ''
                }
                onChange={handleSelectChange('i_submittertype')}
                name="i_submittertype"
                options={props.directories.submitterType.filter(({value}) => value !== 2)}
                styles={styles.customStyles}
                placeholder=""
                // isLoading={
                //   this.props.isFatching.DATA_FROM_DIRECTORIES
                // }
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !props.applicant.i_submittertype && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>{' '}
      </Grid>
      {/* container finished */}
      {/* container start */}
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="telephone">Телефон </label>{' '}
            <PhoneInput
              className={!valid.phone ? 'error' : ''}
              name="telephone"
              type="text"
              value={props.applicant.telephone}
              onChange={handleInputChange}
              autoComplete="off"
            />{' '}
            {!(submitted && !props.applicant.telephone) && !valid.phone && (
              <FormHelperText error id="name-error-text">
                {' '}
                Не валідне значення поля
              </FormHelperText>
            )}{' '}
            {submitted && !props.applicant.telephone && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="email">Електронна адреса </label>{' '}
            <EmailInput
              className={!valid.email ? 'error' : ''}
              name="email"
              type="text"
              value={props.applicant.email}
              onChange={handleInputChange}
            />{' '}
            {!(submitted && !props.applicant.email) && !valid.email && (
              <FormHelperText error id="name-error-text">
                {' '}
                Не валідне значення поля
              </FormHelperText>
            )}{' '}
            {submitted && !props.applicant.email && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '}
          </div>{' '}
        </Grid>{' '}
      </Grid>
      {/* container finishide */}

      <Grid container direction="row" spacing={2}>
        <Grid item xs={12}>
          {/* {props.activeStep === 0 &&<Button
            disabled={props.activeStep === 0}
            onClick={props.handleBack}
            // className={classes.button}
          >
            Назад
          </Button>} */}
          <Button
            variant="contained"
            color="secondary"
            // onClick={props.handleNext}
            onClick={handleSaveProfile}

            // className={classes.button}
          >
            {/* Next */}
            Зберегти
          </Button>
          {/* {props.activeStep !== props.steps.length &&
                (props.completed[props.activeStep] ? (
                  <Typography variant="caption">
                    Step {props.activeStep + 1} already completed
                  </Typography>
                ) : ( */}
          {/* <Button variant="contained" color="primary" onClick={handleComplete}> */}
          {/* {props.completedSteps() === props.totalSteps() - 1
                      ? 'Finish' */}
          {/* :  */}
          {/* Complete Step */}
          {/* '} */}
          {/* </Button> */}
          {/* ))} */}
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  applicant: state.applicant,
  directories: state.directories,
  application: state.application,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, { saveApplicant, apllicantData })(Profile);
